import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, AlertCircle, Loader2 } from "lucide-react";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";

export default function GoogleCallbackPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const ok = params.get("ok") === "1";
  const error = params.get("error");
  const email = params.get("email");
  const return_to = params.get("return_to") || "/";

  useEffect(() => {
    if (ok) {
      const t = setTimeout(() => navigate(return_to || "/"), 2200);
      return () => clearTimeout(t);
    }
  }, [ok, navigate, return_to]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#F6F8FC]">
      <div className="w-full max-w-md cxo-card p-8 text-center">
        <Logo />
        {ok && (
          <>
            <div className="mt-4 inline-flex w-16 h-16 rounded-full bg-[#E9F8F1] text-[#1F9D6A] items-center justify-center"><CheckCircle2 size={32} /></div>
            <h1 className="mt-3 font-display text-2xl font-bold text-slate-900">Google Calendar collegato</h1>
            {email && <p className="mt-1 text-sm text-slate-600">Account: <strong>{email}</strong></p>}
            <p className="mt-3 text-xs text-slate-500">Ti reindirizzo automaticamente...</p>
            <Loader2 size={16} className="mt-2 animate-spin text-slate-400 mx-auto" />
          </>
        )}
        {error && (
          <>
            <div className="mt-4 inline-flex w-16 h-16 rounded-full bg-red-50 text-red-600 items-center justify-center"><AlertCircle size={32} /></div>
            <h1 className="mt-3 font-display text-2xl font-bold text-slate-900">Errore connessione Google</h1>
            <p className="mt-1 text-sm text-slate-600">{error}</p>
            <Button onClick={() => navigate(return_to)} className="mt-4 bg-[#2D6BFF] text-white">Torna indietro</Button>
          </>
        )}
        {!ok && !error && (
          <>
            <Loader2 size={24} className="animate-spin text-slate-400 mt-4 mx-auto" />
            <p className="mt-3 text-sm text-slate-600">Elaborazione in corso...</p>
          </>
        )}
      </div>
    </div>
  );
}
